import { render, staticRenderFns } from "./project-progression-report.vue?vue&type=template&id=0d489f25&scoped=true&"
import script from "./project-progression-report.vue?vue&type=script&lang=js&"
export * from "./project-progression-report.vue?vue&type=script&lang=js&"
import style0 from "./project-progression-report.vue?vue&type=style&index=0&id=0d489f25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d489f25",
  null
  
)

export default component.exports